// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';

import { Grid, Stack } from '@metarouter-private/mr-mui';
import { MrAppLayout, MrAppMain } from '@ion/components';

import SideNav from 'app/components/side-nav';

import AuditLogModal from 'app/audit-logs/AuditLogModal';
import AuditLogDetailButton from 'app/audit-logs/AuditLogDetailButton';
import useAuditLogAffordanceVisible from 'app/audit-logs/useAuditLogAffordanceVisible';

import AnalyticsFileTable from './AnalyticsFileTable';

import PipelineDetailsPageHeader from './PipelineDetailsPageHeader';
import { usePipelinePageContext } from './PipelinePageContextProvider';
import usePipelineAuditLogModal from './usePipelineAuditLogModal';

import StatusItem from './StatusItem';
import PipelineIntegrationsSection from './PipelineIntegrationsSection';
import SchemaEnforcementItem from './SchemaEnforcementItem';
import PipelineTransformationsSection from './PipelineTransformationsSection/PipelineTransformationsSection';

// Box with sx is required here — Stack/Grid don't support targeting child
// MuiPaper-root elements for equal-height stretching across the top row cards.
const TOP_ROW_ITEM_CONTENT_STYLES = {
  width: '100%',
  height: '100%',
  '& > .MuiPaper-root': {
    height: '100%',
  },
};

export default function PipelineDetailsContent() {
  const { loading } = usePipelinePageContext();
  const { open, openModal, closeModal, recordRef } = usePipelineAuditLogModal();
  const auditLogVisible = useAuditLogAffordanceVisible();

  return (
    <MrAppLayout title="Pipelines" header={<PipelineDetailsPageHeader />} sideNav={<SideNav />}>
      <MrAppMain loading={loading}>
        {!loading && (
          <Stack spacing={2}>
            {auditLogVisible && (
              <Stack direction="row" justifyContent="flex-end">
                <AuditLogDetailButton onClick={openModal} />
              </Stack>
            )}
            <Grid container spacing={2} alignItems="stretch">
              <Grid item xs={4}>
                <Stack sx={TOP_ROW_ITEM_CONTENT_STYLES}>
                  <StatusItem />
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack sx={TOP_ROW_ITEM_CONTENT_STYLES}>
                  <AnalyticsFileTable />
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack sx={TOP_ROW_ITEM_CONTENT_STYLES}>
                  <SchemaEnforcementItem />
                </Stack>
              </Grid>
            </Grid>
            <PipelineTransformationsSection />
            <PipelineIntegrationsSection />
          </Stack>
        )}
      </MrAppMain>
      <AuditLogModal open={open} onClose={closeModal} recordRef={recordRef} />
    </MrAppLayout>
  );
}
